<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style lang="scss">
.van-icon__image {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
}
.van-field__control:disabled {
  -webkit-text-fill-color: #333 !important;
}
.van-cell::after {
  border-bottom: 0px solid #ebedf0 !important;
}
@import "./assets/styles/comm.scss";
::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
  -webkit-appearance: none;
  background: transparent;
}
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  height: 100%;
}
</style>
